import React from 'react';

import { Callout } from '@vk-hr-tek/ui/Callout';
import { Typography } from '@vk-hr-tek/ui/Typography';

export const PassedSurveyNotification = () => {
  return (
    <Callout variant="warning">
      <Typography variant="body3" color="accent.text.warning">
        Опрос уже пройден участниками. При внесении изменений во все поля
        опроса, кроме «Показать ответы» и «Дата завершения», ответы участников
        будут безвозвратно удалены
      </Typography>
    </Callout>
  );
};
